<template>
    <div>
        <CRow>
            <CCol>
                <CCard accent-color="info">
                    <CCardHeader>
                        <h4>Balance Comparativo</h4>
                    </CCardHeader>
                    
                    <CCardBody>
                        <CRow>
                            <CCol md="3">
                                <multiselect
                                    class="mb-2"
                                    :custom-label="customLabelEmp"
                                    v-model="empSelected"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Quitar"
                                    selectLabel="Seleccionar"
                                    placeholder="Seleccionar Empresa" 
                                    label="nombreEmpresa" 
                                    track-by="codEmpresa" 
                                    :options="empresasInfo" 
                                    :multiple="false"
                                    @select="seleccionarEmpresa"></multiselect>
                            </CCol>
                            <CCol md="2">
                                <multiselect class="m-0 d-inline-block mb-2" 
                                    v-model="mesDesdeSelected"
                                    deselect-label="" 
                                    placeholder="Desde" 
                                    select-label=""
                                    selectedLabel=""
                                    label="nombre" 
                                    track-by="valor" 
                                    :options="mesesDesde" 
                                    :searchable="true"
                                    :disabled="empSelected == null"
                                    @select="seleccionarMesDesde"
                                >
                                </multiselect>
                            </CCol>
                            <CCol md="2">
                                <multiselect class="m-0 d-inline-block mb-2" 
                                    v-model="mesHastaSelected"
                                    deselect-label="" 
                                    placeholder="Hasta" 
                                    select-label=""
                                    selectedLabel=""
                                    label="nombre" 
                                    track-by="valor" 
                                    :options="mesesHasta" 
                                    :searchable="true"
                                    :disabled="empSelected == null"
                                    @select="seleccionarMesHasta"
                                >
                                </multiselect>
                            </CCol>
                            <CCol md="2">
                                <multiselect class="m-0 d-inline-block mb-2" 
                                    v-model="anio1Selected"
                                    deselect-label="" 
                                    placeholder="Año 1" 
                                    select-label=""
                                    selectedLabel=""
                                    label="valor" 
                                    track-by="valor" 
                                    :options="aniosDesde" 
                                    :searchable="true"
                                    @select="seleccionarAnioDesde"
                                >
                                </multiselect>
                            </CCol>
                            <CCol md="2">
                                <multiselect class="m-0 d-inline-block mb-2" 
                                    v-model="anio2Selected"
                                    deselect-label="" 
                                    placeholder="Año 2" 
                                    select-label=""
                                    selectedLabel=""
                                    label="valor" 
                                    track-by="valor" 
                                    :options="aniosHasta" 
                                    :searchable="true"
                                    @select="seleccionarAnioHasta"
                                >
                                </multiselect>
                            </CCol>
                            <CCol md="1">
                                <!--<CButton
                                    class="mb-1"
                                    style="width:auto"
                                    variant="ghost"
                                    size="lg"
                                    color="success"
                                    @click="generarPdf"
                                    :disabled="isLoadingPdfEstadoResultados"
                                > 
                                    <CIcon :content="$options.freeSet.cilCloudDownload" /> Descargar pdf
                                </CButton>-->
                                <CRow>
                                    <CCol>
                                        <CButton
                                            v-show="mesDesdeSelected != null && mesHastaSelected != null && anio1Selected != null && anio2Selected != null && empSelected != null"
                                            size="sm"
                                            variant="ghost"
                                            class="btnPrincipalVapp mb-1"
                                            @click="generarPdf"
                                            :disabled="isLoadingPdf"
                                            v-c-tooltip.hover="{content: 'Descargar PDF',placement: 'over'}">
                                                <CIcon v-if="isLoadingPdf" :content="$options.freeSet.cilCloudDownload" class="imgr" />
                                                <CIcon v-else :content="$options.freeSet.cilCloudDownload" />
                                                PDF
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol>
                                        <CButton
                                            v-show="mesDesdeSelected != null && mesHastaSelected != null && anio1Selected != null && anio2Selected != null && empSelected != null"
                                            size="sm"
                                            variant="ghost"
                                            class="btnPrincipalVapp mb-1"
                                            @click="generarCsv"
                                            :disabled="isLoadingCsv"
                                            v-c-tooltip.hover="{content: 'Descargar CSV',placement: 'over'}" 
                                            >
                                                <CIcon v-if="isLoadingCsv" :content="$options.freeSet.cilCloudDownload" class="imgr"  />
                                                <CIcon v-else :content="$options.freeSet.cilCloudDownload" />
                                                CSV
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCol>
                            
                        </CRow>
                        
                        <CRow>
                            <CCol col="12">
                                <a-table
                                    row-key="codigo"
                                    :columns="columnasBalance" 
                                    :data-source="balanceComparativo"
                                    :pagination="{'pageSize': totalPagina}"
                                    :scroll="{ x: 1600, y: 400 }"
                                    :loading="isLoadingBalanceComparativo"
                                    class="components-table-demo-nested mt-3" 
                                    size="small" >
                                        <span slot="codigo" slot-scope="bl">
                                            {{bl.codigo}}
                                        </span>
                                        <span slot="descripcion" slot-scope="bl">
                                            {{bl.descripcion}}
                                        </span>
                                        <span slot="debito" slot-scope="bl">
                                            {{bl.debito | currency}}
                                        </span>
                                        <span slot="debito2" slot-scope="bl">
                                            {{bl.debito2 | currency}}
                                        </span>
                                        <span slot="credito" slot-scope="bl">
                                            {{bl.credito | currency}}
                                        </span>
                                        <span slot="credito2" slot-scope="bl">
                                            {{bl.credito2 | currency}}
                                        </span>
                                        <span slot="deudor" slot-scope="bl">
                                            {{bl.deudor | currency}}
                                        </span>
                                        <span slot="deudor2" slot-scope="bl">
                                            {{bl.deudor2 | currency}}
                                        </span>
                                        <span slot="acreedor" slot-scope="bl">
                                            {{bl.acreedor | currency}}
                                        </span>
                                        <span slot="acreedor2" slot-scope="bl">
                                            {{bl.acreedor2 | currency}}
                                        </span>
                                        <span slot="activo" slot-scope="bl">
                                            {{bl.activo | currency}}
                                        </span>
                                        <span slot="activo2" slot-scope="bl">
                                            {{bl.activo2 | currency}}
                                        </span>
                                        <span slot="pasivo" slot-scope="bl">
                                            {{bl.pasivo | currency}}
                                        </span>
                                        <span slot="pasivo2" slot-scope="bl">
                                            {{bl.pasivo2 | currency}}
                                        </span>
                                        <span slot="perdida" slot-scope="bl">
                                            {{bl.perdida | currency}}
                                        </span>
                                        <span slot="perdida2" slot-scope="bl">
                                            {{bl.perdida2 | currency}}
                                        </span>
                                        <span slot="ganancia" slot-scope="bl">
                                            {{bl.ganancia | currency}}
                                        </span>
                                        <span slot="ganancia2" slot-scope="bl">
                                            {{bl.ganancia2 | currency}}
                                        </span>
                                </a-table>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    
    import cons from '@/const'
    import axios from "axios"

    import Multiselect from 'vue-multiselect'

    import VueModal from '@kouts/vue-modal';
    import '@kouts/vue-modal/dist/vue-modal.css';
    
    import { freeSet } from '@coreui/icons'

    import moment from 'moment'
    import { format, formatDistance, formatRelative, subDays } from 'date-fns'
    import es from 'date-fns/locale/es'
    window.locale = 'es'

    

    export default {
        name: 'BalanceComparativo',
        freeSet,
        components: {
            Multiselect,
            'Modal': VueModal
        },
        data () {
            return {
                urlBase: cons.port+"://" + cons.ipServer,
                
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                tipoUserAdmin: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,
                idCliente: JSON.parse(this.$cookie.get('userLogginToken')).idCliente,
                
                regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                
                totalPagina: 20,
                mesesDesde: [
                    {"nombre": "Enero", "valor": 1 }, 
                    {"nombre": "Febrero", "valor": 2}, 
                    {"nombre": "Marzo", "valor": 3}, 
                    {"nombre": "Abril", "valor": 4}, 
                    {"nombre": "Mayo", "valor": 5}, 
                    {"nombre": "Junio", "valor": 6}, 
                    {"nombre": "Julio", "valor": 7}, 
                    {"nombre": "Agosto", "valor": 8}, 
                    {"nombre": "Septiembre", "valor": 9}, 
                    {"nombre": "Octubre", "valor": 10}, 
                    {"nombre": "Noviembre", "valor": 11}, 
                    {"nombre": "Diciembre", "valor": 12}
                ],
                mesesHasta: [
                    {"nombre": "Enero", "valor": 1, $isDisabled: false}, 
                    {"nombre": "Febrero", "valor": 2, $isDisabled: false}, 
                    {"nombre": "Marzo", "valor": 3, $isDisabled: false}, 
                    {"nombre": "Abril", "valor": 4, $isDisabled: false}, 
                    {"nombre": "Mayo", "valor": 5, $isDisabled: false}, 
                    {"nombre": "Junio", "valor": 6, $isDisabled: false}, 
                    {"nombre": "Julio", "valor": 7, $isDisabled: false}, 
                    {"nombre": "Agosto", "valor": 8, $isDisabled: false}, 
                    {"nombre": "Septiembre", "valor": 9, $isDisabled: false}, 
                    {"nombre": "Octubre", "valor": 10, $isDisabled: false}, 
                    {"nombre": "Noviembre", "valor": 11, $isDisabled: false}, 
                    {"nombre": "Diciembre", "valor": 12, $isDisabled: false}
                ],

                
                aniosDesde: [
                    {"valor": 2022},
                    {"valor": 2021},
                    {"valor": 2020},
                    {"valor": 2019},
                    {"valor": 2018}
                ],

                aniosHasta: [
                    {"valor": 2022, $isDisabled: false},
                    {"valor": 2021, $isDisabled: false},
                    {"valor": 2020, $isDisabled: false},
                    {"valor": 2019, $isDisabled: false},
                    {"valor": 2018, $isDisabled: false}
                ],

                mesDesdeSelected: null,
                mesHastaSelected: null,
                
                anio1Selected: null,
                anio2Selected: null,

                empresasInfo: [],

                empSelected: null,

                
                isLoadingEmpresasInfo: false,
                isLoadingBalanceComparativo: false,
                isLoadingPdf: false,
                isLoadingCsv: false,

                columnasBalance: [
                    { title: 'Código', scopedSlots: { customRender: 'codigo' }, width: '5%', align: 'left', ellipsis: false},
                    { title: 'Descripción', scopedSlots:{ customRender: 'descripcion' }, width: '5%', align: 'right', ellipsis: false},
                    { title: 'debito', scopedSlots: { customRender: 'debito' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'debito A2', scopedSlots: { customRender: 'debito2' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'credito', scopedSlots: { customRender: 'credito' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'credito A2', scopedSlots: { customRender: 'credito2' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'deudor', scopedSlots: { customRender: 'deudor' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'deudor A2', scopedSlots: { customRender: 'deudor2' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'acreedor', scopedSlots: { customRender: 'acreedor' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'acreedor A2', scopedSlots: { customRender: 'acreedor2' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'activo', scopedSlots: { customRender: 'activo' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'activo A2', scopedSlots: { customRender: 'activo2' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'pasivo', scopedSlots: { customRender: 'pasivo' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'pasivo A2', scopedSlots: { customRender: 'pasivo2' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'perdida', scopedSlots: { customRender: 'perdida' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'perdida A2', scopedSlots: { customRender: 'perdida2' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'ganancia', scopedSlots: { customRender: 'ganancia' }, width: '5%', align: 'center', ellipsis: false},
                    { title: 'ganancia A2', scopedSlots: { customRender: 'ganancia2' }, width: '5%', align: 'center', ellipsis: false}
                ],
                balanceComparativo: [],

            }
        },
        created: function(){},
        beforeMount() {
            let cookieUsername = this.$cookie.get('userLogginToken')
            if(cookieUsername === null || cookieUsername === ""){
                this.$router.push("/pages/login");
            }

        },
        mounted(){
            this.obtenerSoloInfoEmpresas()
        },
        methods: {
            generarCsv: function(){

                this.isLoadingCsv = true

                var url = this.urlBase + "/generar_csv_balance";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa,
                            "mesDesde": this.mesDesdeSelected.nombre,
                            "mesHasta": this.mesHastaSelected.nombre,
                            "anio": this.anio1Selected.valor,
                            "comparativo": true,
                            "anio2": this.anio2Selected.valor
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    this.isLoadingCsv = false
                    
                    var link = result.data.archivoGenerado.link

                    
                    var fileLink = document.createElement("a");
                    fileLink.href = link;
                    fileLink.setAttribute("download", result.data.archivoGenerado.nombre);
                    document.body.appendChild(fileLink);
                    fileLink.click();

                    this.$notification.success(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );

                }, error => {
                    this.isLoadingCsv = false
                    this.$notification.error(
                        error.response.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );
                });
            },
            generarPdf: function(){

                this.isLoadingPdf = true

                var url = this.urlBase + "/generar_pdf_balance";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa,
                            "mesDesde": this.mesDesdeSelected.nombre,
                            "mesHasta": this.mesHastaSelected.nombre,
                            "anio": this.anio1Selected.valor,
                            "comparativo": true,
                            "anio2": this.anio2Selected.valor
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    this.isLoadingPdf = false
                    
                    var link = result.data.archivoGenerado.link

                    
                    var fileLink = document.createElement("a");
                    fileLink.href = link;
                    fileLink.setAttribute("download", result.data.archivoGenerado.nombre);
                    document.body.appendChild(fileLink);
                    fileLink.click();

                    this.$notification.success(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );

                }, error => {
                    this.isLoadingPdf = false
                    this.$notification.error(
                        error.response.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );
                });
            },
            obtenerSoloInfoEmpresas: function(){
                this.isLoadingEmpresasInfo = true
                var url = cons.port+"://" + cons.ipServer + "/get_empresas_info/CONTA";
                
                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    this.empresasInfo = result.data;

                }, error => {
                    //let mensaje = `Problema al obtener empresas , ${error}`
                    //this.textoSinEmpresas = mensaje
                })
                .finally(() => {
                    this.isLoadingEmpresasInfo = false
                });
            },

            getBalanceComp: function(anio2){
                 this.isLoadingBalanceComparativo = true
                this.anio2Selected = anio2
                this.balanceComparativo = []

                var url = this.urlBase + "/get_balance_empresa";
                
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa,
                            "mesDesde": this.mesDesdeSelected.nombre,
                            "mesHasta": this.mesHastaSelected.nombre,
                            "anio": this.anio1Selected.valor,
                            "comparativo": true,
                            "anio2": this.anio2Selected.valor
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    this.totalPagina = result.data.length
                    this.balanceComparativo = result.data;
                    this.isLoadingBalanceComparativo = false

                }, error => {

                    this.isLoadingBalanceComparativo = false
                    this.$notification.error(
                        error.response.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );
                });
            },

            
            
            seleccionarEmpresa: function(emp){
                this.empSelected = emp
                if(this.mesDesdeSelected != null && this.mesHastaSelected != null && this.anio1Selected != null && this.anio2Selected != null){
                    this.getBalanceComp(this.anio2Selected)
                }

            },
            seleccionarMesDesde: function(mesDesde){
                this.validarMesHasta(mesDesde)
                this.mesDesdeSelected = mesDesde
                if(this.mesHastaSelected != null){
                    if(this.mesHastaSelected.valor < mesDesde.valor){
                        this.mesHastaSelected = null
                    } else{
                        if(this.empSelected != null && this.mesHastaSelected != null && this.anio1Selected != null && this.anio2Selected != null){
                            this.getBalanceComp(this.anio2Selected)
                        }
                    }
                }
            },
            seleccionarMesHasta: function(mesHasta){
                this.mesHasta = mesHasta
                if(this.empSelected != null && this.mesDesdeSelected != null && this.anio1Selected != null && this.anio2Selected != null){
                    this.getBalanceComp(this.anio2Selected)
                }
            },

            seleccionarAnioDesde: function(anio){
                this.validarAnioHasta(anio)
                this.anio1Selected = anio
                if(this.empSelected != null && this.mesDesdeSelected != null && this.mesHastaSelected != null && this.anio2Selected != null){
                    this.getBalanceComp(this.anio2Selected)
                }
            },
            seleccionarAnioHasta: function(anio){
                this.anio2Selected = anio
                if(this.empSelected != null && this.mesDesdeSelected != null && this.mesHastaSelected != null && this.anio1Selected != null){
                    this.getBalanceComp(this.anio2Selected)
                }
            },
            

            validarAnioHasta: function(opcion){
                this.aniosHasta.forEach(anio => {
                    if(anio.valor < opcion.valor){
                        anio.$isDisabled = true
                    } else{
                        anio.$isDisabled = false
                    }
                })
            },

            validarMesHasta: function(opcion){
                this.mesesHasta.forEach(mes =>{
                    if(mes.valor < opcion.valor){
                        mes.$isDisabled = true
                    }
                    else{
                        mes.$isDisabled = false
                    }
                })
            },

            customLabelEmp (empresa) {
                return `(${empresa.codEmpresa}) ${empresa.nombreEmpresa}`;
            },
        }
        
    }
</script>

<style>
    .imgr{
    -webkit-animation: 3s rotate linear infinite;
    animation: 3s rotate  linear infinite;
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    }
</style>